<template>
  <div class="report-ve-awards">
    <transition name="fadepopup">
      <div v-if="isPopupVisible" class="popup">
        <button class="close-button" @click="hidePopup">X</button><br>
        <p>Employee Nomination records download has started. Once it is complete, the file will automatically download to your browser.</p>
      </div>
    </transition>
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="$route.name"></ContentHeader>
        <div class="alert alert-info" style="padding-bottom:30px">
          <button type="button" class="btn btn-primary float-right showHideBtn" v-b-toggle.filterControls v-on:click="showHideFilters()" title="Show/Hide Filters" v-b-tooltip.hover>
            <span v-html="showHideFilterText"></span>
          </button>
          <div class="mr-2 float-right">
            Download current view as:
            <button type="button" class="btn btn-link p-0" :disabled="buttonExportFullReportDisabled" v-on:click="exportFullReportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download All records as Exel file"></i>
            </button>
            <button type="button" class="btn btn-link p-0" :disabled="buttonExportFullReportDisabled" v-on:click="exportToCSV()">
              <i class="fas fa-file-excel fa-2x" v-b-tooltip.hover title="Download as an Excel file"></i>
            </button>
            <!--button type="button" class="btn btn-link p-0" v-on:click="exportToPDF()">
              <i class="fas fa-file-pdf fa-fw fa-2x" title="Download as a PDF document" v-b-tooltip.hover></i>
            </button-->
          </div>
          <h4 class="alert-heading">Filtered Search</h4>
          <b-collapse visible id="filterControls" accordion="link-accordion" role="tabpanel">
            <hr>
            <div class="row">
              <div class="col-sm-4 mb-2">
                <label>Nomination Category</label>
                <select v-model="nominationCategorySelect" v-on:change="categoryChange()" class="form-control">
                  <option>-- All --</option>
                  <option v-for="category in nominationCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-3 mb-2">
                <label for="nominatorFilter">From Date:</label>
                <div class="input-group">
                  <!--input type="date" ref="fromDate" name="fromDate" id="fromDate" :value="fromDate" v-on:change="dateFilters()" /-->
                  <template>
                    <div style="position: relative;">
                      <label for="begin" style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                        {{ formattedFromDate }}
                      </label>
                      <input type="date" ref="datepicker"
                        :value="fromDate" 
                        @input="updateFromDate" @blur="hideDatepicker" v-on:change="dateFilters()"
                        style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                      />
                    </div><BR/>
                  </template>
                  <!-- <input type="text" id="nominatorFilter" v-model="nominatorFilter" v-on:keyup.enter="filterByNominator()" class="form-control" placeholder="Enter name...">
                  <div class="input-group-append">
                    <button v-on:click="filterByNominator()" type="submit" id="searchsubmit" class="btn btn-primary">{{nominatorFilterButton}}</button>
                  </div> -->
                </div>
              </div>
              <div class="col-sm-3 mb-2">
                <label for="nomineeFilter">To Date:</label>
                <div class="input-group">
                  <!--input type="date" ref="toDate" name="toDate" id="toDate" :value="toDate" v-on:change="dateFilters()" /-->
                  <template>
                    <div style="position: relative;">
                      <label
                        for="end"
                        style="position: absolute;top: 4px;left: 4px;width: 120px;z-index: 1;cursor: pointer;padding: 0px;background: white;">
                        {{ formattedToDate }}
                      </label>
                      <input
                        type="date"
                        ref="datepicker"
                        :value="toDate"
                        @input="updateToDate"
                        @blur="hideDatepicker"
                        v-on:change="dateFilters()"
                        style="position: absolute;top: 0px;left: 0px;width: 150px;padding:3px;display: block;border: 1px solid black;"
                      />
                    </div><BR/>
                  </template>
                </div>                
              </div>
            </div>
          </b-collapse>
        </div>
        <!--NominationReportEntries v-if="nominations.length > 0" :nominations="nominations"></NominationReportEntries-->
        <NominationReportEntries v-if="nominations.length > 0 && nominationCategorySelect !== 138 && nominationCategorySelect !== 100" :nominations="nominations"></NominationReportEntries>
        <NominationEmployeeReportEntries v-if="nominations.length > 0 && (nominationCategorySelect === 138 || nominationCategorySelect === 100) " :nominations="nominations"></NominationEmployeeReportEntries>

        <span v-if="nominations.length === 0">
          No nominations have been submitted
        </span>
      </div>
    </transition>
    <iframe id="iFramePdf" src="myPdfUrl.pdf" style="display:none;"></iframe>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ExportToCSV from '@/helpers/ExportToCSV.js'
import ContentHeader from '@/components/ContentHeader'
import NominationReportEntries from '@/components/NominationReportGroupEntries'
import NominationEmployeeReportEntries from '@/components/NominationEmployeeReportEntries'
import PreContentHeader from '@/components/PreContentHeader'

export default {
  components: {
    PreContentHeader,
    ContentHeader,
    NominationReportEntries,
    NominationEmployeeReportEntries
  },
  data () {
    return {
      isPopupVisible: false,
      buttonExportFullReportDisabled: false,
      nominations: [],
      totalNominations: [],
      unfilteredNominations: [],
      contentReady: false,
      contentLoadError: '',
      graduatedNominationsCheck: false,
      nominationCategories: [],
      nominationCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      nominatorFilter: '',
      nominatorFilterButton: '+',
      nomineeFilter: '',
      nomineeFilterButton: '+',
      showHideFilterText: '<i class="fas fa-angle-up"></i>',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10,
      toDate: '',
      fromDate: '',
      userDetails: null,
      userType: 'HRBP',
      totalRecords: 0,
      approved: 0,
      rejected: 0,
      pending: 0,
      showDatepickerFlag: true,
      minDate: '',
      maxDate: ''
    }
  },
  computed: {
    nominationCounts: function () {
      return {
        total: this.totalPosts,
        pending: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Pending').length,
        accepted: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Accepted').length,
        declined: this.nominations.filter(x => x.nomination_approve_decline && x.nomination_approve_decline[0] === 'Declined').length
      }
    },
    formattedFromDate() {
      if (!this.fromDate) return ''
      const date = new Date(this.fromDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return this.fromDate
    },
    formattedToDate() {
      if (!this.toDate) return ''
      const date = new Date(this.toDate)
      const day = ('0' + date.getDate()).slice(-2)
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const year = date.getFullYear()
      return this.toDate
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('nomination_event_category?per_page=100')
      .then(response => {
        this.nominationCategories = response.data.filter(x => x.id == 103 || x.id == 104 || x.id == 102 || x.id == 100 || x.id == 138 || x.id == 139 || x.id == 140 || x.id == 141)
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1 // Adding 1 since January is 0
        const day = today.getDate()
        const financialYear = month < 4 ? year - 1 : year
        const formattedDate = `${financialYear}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
        this.toDate = `${financialYear + 1}-03-31`
        this.fromDate = `${financialYear}-04-01`
        this.loadNominations()  
      })
      .catch(e => {
        console.error(e)
      })
    WordpressRestAPI.getViewContent('community_categories?per_page=100')
      .then(response => {
        this.communityCategories = response.data
      })
      .catch(e => {
        console.error(e)
      })
  },
  methods: {
    showDatepicker() {
      this.showDatepickerFlag = true;
      this.$nextTick(() => {
        this.$refs.datepicker.focus();
      });
    },
    updateFromDate(event) {
      this.fromDate = event.target.value;
      this.$emit('change', this.fromDate);
      this.showDatepicker = false;
    },
    updateToDate(event) {
      this.toDate = event.target.value;
      this.$emit('change', this.toDate);
      this.showDatepicker = false;
    },
    hideDatepicker() {
      setTimeout(() => {
        this.showDatepicker = false;
      }, 200000); // delay to allow date selection before hiding
    },      
    getNominationCounts: function () {
      this.approved = 0
      this.rejected = 0
      this.pending = 0
      var index = 0
      this.nominations.forEach(item => {
        if (index < this.itemsPerPage) {
            if (item.teamnominationworkflow[0][2].project_sponsor_status === 'Approve') {
                this.approved++
            } else if (item.teamnominationworkflow[0][2].project_sponsor_status === 'Reject') {
                this.rejected++
            } else if (item.teamnominationworkflow[0][2].project_sponsor_status === '') {
            this.pending++
            }
            index++
        }
      });
      if (this.nominations.length < this.itemsPerPage) {
        this.totalRecords = this.nominations.length
      } else {
        this.totalRecords = this.itemsPerPage
      }
    },
    categoryChange: function () {
      this.currentPage = 1
      this.itemsPerPage = 10
      this.loadNominations()
    },
    exportToPDF: function () {
      window.print()
    },
    validateDates: function() {
      if (this.$refs.toDate)
        this.toDate = this.$refs.toDate.value

      if (this.$refs.fromDate)
        this.fromDate = this.$refs.fromDate.value
        
      const fromDate = new Date(this.fromDate)
      const toDate = new Date(this.toDate)

      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth() + 1 // Adding 1 since January is 0
      const financialYearStart = month < 4 ? year - 1 : year

      if (toDate < fromDate) {
        alert('To Date should be greater than From Date')
        this.fromDate = `${financialYearStart}-04-01`
        this.toDate =   `${financialYearStart + 1}-03-31`
        return false
      }

      if ( this.toDate !== '' && this.fromDate !== '' ) {
        return '&after=' + this.fromDate + ' 00:00:00&before=' + this.toDate + ' 23:59:59'
      }
      return ''
    },
    exportContentData: function (data) {
      var chunks = data[0].split(' @#$% ')
      var header = ''
      var value = ''
      var exportData = []
      chunks.map(function (val, index) {
        if (val.indexOf('<h>') > -1) {
          header = val.replace(/<h>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';')
        }
        if (val.indexOf('<c>') > -1) {
          value = val.replace(/<c>/g, '').replace(/<strong>/g, '').replace(/<\/strong>/g, '').replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<li>/g, '').replace(/<\/li>/g, '').replace(/<br>/g, ' ').replace(/<br\/>/g, ' ').replace(/,/g, ';').replace(/�/g, '\'').replace(/�/g, '"').replace(/�/g, '"')
          exportData[header] = value
        }
      })
      return exportData
    },
    getSingleNomineeInfo: function (x) {
      var nomineesInfo = { 'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'department': [], 'country': [], 'gom': [], 'projectSponsor': '', 'projectSponsorApproved': '', 'projectSponsorDeclinedReason': '', 'projectSponsorDate': '' }
      nomineesInfo.nomineeName = x.nominee_name[0]
      nomineesInfo.nomineeEmployeNumber = x.nominee_employeeNumber[0]
      nomineesInfo.nomineeEmail = x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.')
      nomineesInfo.nomineeCompany = (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : ''
      nomineesInfo.businessUnit = ' '
      nomineesInfo.department = ' '
      nomineesInfo.country = ' '
      nomineesInfo.gom = ' '
      if ('employeehierarchy' in x.nominee_slug && x.nominee_slug.employeehierarchy) {
        nomineesInfo.nomineeEmail = x.nominee_slug[1]
        nomineesInfo.businessUnit = 'businessunit' in x.nominee_slug.employeehierarchy ? x.nominee_slug.employeehierarchy.businessunit[0] : ''
        nomineesInfo.department =  (x.nominee_slug.employeehierarchy &&  x.nominee_slug.employeehierarchy['departmentname'] && Array.isArray(x.nominee_slug.employeehierarchy['departmentname']) &&
   x.nominee_slug.employeehierarchy['departmentname'][0]) ? x.nominee_slug.employeehierarchy['departmentname'][0] : ''
        nomineesInfo.country = x.nominee_slug.employeehierarchy.country[0]
        nomineesInfo.gom = x.nominee_slug.employeehierarchy.gom[0]
        if ('employeenumber' in x.nominee_slug.employeehierarchy)
          nomineesInfo.nomineeEmployeNumber = x.nominee_slug.employeehierarchy.employeenumber[0]
      }
      console.log(' getSingleNomineeInfo ', x, nomineesInfo, x.nominee_slug, x.nominee_slug[0])
      return nomineesInfo
    },
    getNomineeInfo: function (nomineesInfo, x, i, count) {
      nomineesInfo.nomineeName += (count - 1 === i) ? x.member_name : x.member_name + ' $&$ '
      var nomineeEmployeNumber = (count - 1 === i) ? x.member_employee_number : x.member_employee_number + ' $&$ '
      nomineesInfo.nomineeCompany += (count - 1 === i) ? x.member_company.replace(/,/g, ' ') : x.member_company.replace(/,/g, ' ') + ' $&$ '
      var employeeNumberflag = true
      if (x.member_email.indexOf('@') > -1 && 'businessunit' in x.employeehierarchy) {
        nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_email : x.member_email + ' $&$ '
        nomineesInfo.businessUnit += (count - 1 === i) ? x.employeehierarchy.businessunit[0] : x.employeehierarchy.businessunit[0] + ' $&$ '
        if (x.employeehierarchy && 'departmentname' in x.employeehierarchy && Array.isArray(x.employeehierarchy['departmentname'])) {
          // Safely handle departmentname[0] being null or undefined
          let departmentValue = x.employeehierarchy['departmentname'][0] !== null && 
                                x.employeehierarchy['departmentname'][0] !== undefined 
                                ? x.employeehierarchy['departmentname'][0] : ''

          // Concatenate based on the count logic
          nomineesInfo.department += (count - 1 === i) ? departmentValue : departmentValue + ' $&$ '
        } else {
          // Handle case where departmentname is not present or not an array
          let departmentValue = ''
          nomineesInfo.department += (count - 1 === i) ? departmentValue : departmentValue + ' $&$ '
        }
        nomineesInfo.country += (count - 1 === i) ? x.employeehierarchy.country[0] : x.employeehierarchy.country[0] + ' $&$ '
        nomineesInfo.gom += (count - 1 === i) ? x.employeehierarchy.gom[0] : x.employeehierarchy.gom[0] + ' $&$ '
        if ('employeenumber' in x.employeehierarchy) {
          employeeNumberflag = false
          nomineesInfo.nomineeEmployeNumber += (count - 1 === i) ? x.employeehierarchy.employeenumber[0] : x.employeehierarchy.employeenumber[0] + ' $&$ '
        }
      }
      else {
        nomineesInfo.gom = nomineesInfo.nomineeCompany
        nomineesInfo.businessUnit += (count - 1 === i) ? ' '  : '  $&$ '
        nomineesInfo.department += (count - 1 === i) ? ' ' : ' $&$ '
        nomineesInfo.country += (count - 1 === i) ? ' '  : '  $&$ '
        var emailCreator = ''
        var emailCreatorName = ''
        emailCreator = x.member_name.replace(/ /g, '.') + '@'
        emailCreatorName = x.member_name.toLowerCase().replace(/ /g, '-')
        emailCreator = x.member_slug.replace(emailCreatorName, emailCreator).replace(/-/g, '.')
        if (x.member_company.toLowerCase().indexOf('multichoice') > -1) {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? emailCreator : emailCreator + ' $&$ '
        } else {
          nomineesInfo.nomineeEmail += (count - 1 === i) ? x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') : x.member_slug.replace(/multichoice/g, '@multichoice').replace(/-/g, '.') + ' $&$ '
        }
      }
      if (employeeNumberflag == true)
        nomineesInfo.nomineeEmployeNumber += nomineeEmployeNumber
      return nomineesInfo
    },
    exportTeamData: function (teamDetails) {
      var self = this
      var nomineesInfo = {'nomineeName': [], 'nomineeEmployeNumber': [], 'nomineeEmail': [], 'nomineeCompany': [], 'businessUnit': [], 'department': [], 'country': [], 'gom': []}
      var count = teamDetails.length
      if (count > 1) {
        teamDetails.map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      } else {
        teamDetails[0].map(function (x, i) {
          nomineesInfo = self.getNomineeInfo(nomineesInfo, x, i, count)
        })
      }
      return nomineesInfo
    },
    exportMasterCSV: function (type) {
      var self = this
      var nominationList = []
      if (type === 'Full') {
        nominationList = self.totalNominations
      }
      if (type === 'Partial') {
        nominationList = self.nominations
      }
      // Map fields of nominations array that will be converted to CSV
      const items = nominationList.map(function (x) {
      //const items = this.nominations.map(function (x) {
        var splitData = {}
        var nomineesDetails = {}
        do {
          if (x.teamnominationworkflow[0].length === 1) {
            console.log('moved ->  ')
            x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
          }
        } while (x.teamnominationworkflow[0].length === 1)

        if (x.nominationdata.length) {
          splitData = self.exportContentData(x.nominationdata)
        }
        if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
          nomineesDetails = self.exportTeamData(x.nominationteam[0])
          console.log(' TeamCSVCreate ', x , nomineesDetails)          
          if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
            nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
            nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
            nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
            nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
			const result = nomineesDetails.projectSponsorApproved === 'Approve' ? 'Approved' : nomineesDetails.projectSponsorApproved === 'Reject' ? 'Rejected' : 'Pending'
            nomineesDetails.projectSponsorApproved = result
		  }
        } else {
          nomineesDetails = self.getSingleNomineeInfo(x)    
          //nomineesDetails = {nomineeName: x.nominee_name[0], nomineeEmployeNumber: x.nominee_employeeNumber[0], nomineeEmail: x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.'), nomineeCompany: (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : '', projectSponsor: '', projectSponsorApproved: '', projectSponsorDeclinedReason: '', projectSponsorDate: ''}
        }
        for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
		  //const result = x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' ? 'Approved' : x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' ? 'Rejected' : 'Pending'
		  const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
  x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
  x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
  x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 
  'Pending'
          x.teamnominationworkflow[0][index].project_sponsor_status = result
        }

        var downgrade_user = (x.downgrade_user && x.downgrade_user !== null) ? (x.downgrade_user) : ''
        var Downgrade_Status = ''
        let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered
        if (Award_Category === 'High5') {
            Downgrade_Status = (x.downgrade_status && x.downgrade_status !== null) ? 'Downgraded to High5' :  'Normal High5'
        }
        var Downgrade_Date = ''
        if (Downgrade_Status === 'Downgraded to High5') {
          Downgrade_Date = x.teamnominationworkflow[0][0].project_sponsor_datetime
          if (x.teamnominationworkflow[0].length === 4) {
            if(downgrade_user.toLowerCase() === 'sponsor') {
              x.teamnominationworkflow[0][0].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][1].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][3].project_sponsor_status = 'Downgraded to High5'
            }
            if(downgrade_user.toLowerCase() === 'manager') {
              x.teamnominationworkflow[0][0].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][1].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
            if(downgrade_user.toLowerCase() === 'exco2') {
              x.teamnominationworkflow[0][1].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
            if(downgrade_user.toLowerCase() === 'hrbp') {
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
          }
          if  (x.teamnominationworkflow[0].length === 3) {
            if(downgrade_user.toLowerCase() === 'manager') {
              x.teamnominationworkflow[0][0].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][1].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
            if(downgrade_user.toLowerCase() === 'exco2') {
              x.teamnominationworkflow[0][1].project_sponsor_status = 'Downgraded to High5'
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
            if(downgrade_user.toLowerCase() === 'hrbp') {
              x.teamnominationworkflow[0][2].project_sponsor_status = 'Downgraded to High5'
            }
          }
        }
        var Behavior = self.getBehavior(x)
        if (self.nominationCategorySelect === 100 || self.nominationCategorySelect === 138) {
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            GOM: nomineesDetails.gom,
            BU: nomineesDetails.businessUnit,
            Department: nomineesDetails.department,
            Country: nomineesDetails.country,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            Nominee_Status: x.nomination_approve_decline[0],
            Date_Of_Nomination: x.date.split('T')[0],
            Time_Of_Nomination: x.date.split('T')[1],
            selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
            Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
            Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
            Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
            Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Line_Manager_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
            Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
            Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
            Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
            HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
            HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
            HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            HRBP_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
          }, splitData)
          return temp
        }
        else {
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            GOM: nomineesDetails.nomineeCompany,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            Nominee_Status: x.nomination_approve_decline[0],
            Date_Of_Nomination: x.date.split('T')[0],
            Time_Of_Nomination: x.date.split('T')[1],
            selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
            Project_Sponsor: nomineesDetails.projectSponsor,
            Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
            Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
            Project_Sponsor_Date: nomineesDetails.projectSponsorDate,
            Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
            Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
            Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
            Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
            Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
            Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
            Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || '') : '',
            HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
            HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
            HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
            HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || '') : '',
            Downgrade_Status: Downgrade_Status,
            Downgrade_User: downgrade_user,
            Downgrade_Date:Downgrade_Date,
            Behavior: Behavior
          }, splitData)
          return temp
        }
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' & ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' & ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' & ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' & ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' & ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }

      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
      // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations', 'dateOfNomination')
      console.log('exportMasterCSV call ended')
    },
    exportToCSV: function () {
      this.buttonExportFullReportDisabled = true
      this.isPopupVisible = true          
      var self = this
      if (self.fromDate && self.toDate && self.nominations.length > 0) {
        self.totalLoadNominations('export',true)
        .then(() => {
            console.log('Nominations fetching complete.', self.totalNominations)
            if (self.nominationCategorySelect === "-- All --") {
              self.exportMasterCSV('Full')
            }  
            if (self.nominationCategorySelect === 102) {
              self.high5CSVCreate('Full')
            }
            if (self.nominationCategorySelect === 103) {
              self.OnTheSpotCSVCreate('Full')
            }
            if (self.nominationCategorySelect === 104) {
              self.TeamCSVCreate('Full')
            }
            if (self.nominationCategorySelect === 139) {
              self.BUEOYCSVCreate('Full')
            }
            if (self.nominationCategorySelect === 140) {
              self.MCGEOYCSVCreate('Full')
            }
            if (this.nominationCategorySelect === 141) {
              this.RegionaLEOMCSVCreate('Full')
            }
            if (self.nominationCategorySelect === 100 || self.nominationCategorySelect === 138) {
              self.EmployeeCSVCreate('Full', self.nominationCategorySelect)
            }
            this.isPopupVisible = false
            this.buttonExportFullReportDisabled = false
        })
        .catch(error => {
            console.error('Error:', error);
            this.isPopupVisible = false
            this.buttonExportFullReportDisabled = false            
            // Handle the error if needed
        });
      } else {
        if (!self.fromDate || !self.toDate) {
            alert('Please select date range')
        }  
        else if (self.nominations.length === 0)  {
            alert("No record to download report in given date range.")
        }
        this.isPopupVisible = false
        this.buttonExportFullReportDisabled = false
      }
    },
    high5CSVCreate: function(type) {
        var self = this
        // Map fields of nominations array that will be converted to CSV
        var nominationList = []
        if (type === 'Full') {
          nominationList = self.totalNominations
        }
        if (type === 'Partial') {
          nominationList = self.nominations
        }
        const uniqueNominationList = nominationList.filter((x, index, self) => 
          index === self.findIndex((item) => item.id === x.id)
        );
        self.totalNominations = []
        nominationList = [] 
        console.log(' high5CSVCreate called ')    
        const items = uniqueNominationList.map(function (x) {
        //const items = nominationList.map(function (x) {
        console.log('high5CSVCreate x ', x)        
          var splitData = {}
          var nomineesDetails = {}
          if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
            do {
              if (x.teamnominationworkflow[0].length === 1) {
                console.log('moved ->  ')
                x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
              }
            } while (x.teamnominationworkflow[0].length === 1)
          }
          if (x.nominationdata.length) {
            splitData = self.exportContentData(x.nominationdata)
          }
          if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
            nomineesDetails = self.exportTeamData(x.nominationteam[0])
            console.log(' high5CSVCreate ', x , nomineesDetails)
            if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
              nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
              nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
              nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
              nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
              const result = nomineesDetails.projectSponsorApproved === 'Approve' ? 'Approved' : nomineesDetails.projectSponsorApproved === 'Reject' ? 'Rejected' : 'Pending'
              nomineesDetails.projectSponsorApproved = result
            }
          } else {
            nomineesDetails = self.getSingleNomineeInfo(x)
          }
          for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
            const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 'Pending'
            x.teamnominationworkflow[0][index].project_sponsor_status = result
          }
          var Downgrade_User = (x.downgrade_user && x.downgrade_user !== null) ? (x.downgrade_user) : ''
          var Downgrade_Status = (x.downgrade_status && x.downgrade_status !== null) ? 'Downgraded to High5' :  'Normal High5'
          var Downgrade_Date = ''
          if (Downgrade_Status === 'Downgraded to High5') {
              Downgrade_Date = x.teamnominationworkflow[0][0].project_sponsor_datetime
          }
          let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered
          var Behavior = self.getBehavior(x)
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            Country: nomineesDetails.country,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            GOM: nomineesDetails.gom,
            BU: nomineesDetails.businessUnit,
            Department: nomineesDetails.department,
            Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
            HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',            
            Date_Of_Nomination: x.date.split('T')[0],
            Behavior: Behavior,
            Downgrade_Status: (x.downgrade_status.length && x.downgrade_status !== null) ? 'Downgraded to High5' : 'Normal High5',
            Downgrade_User: (Downgrade_User && Downgrade_User !== null) ? Downgrade_User : '',
            Downgrade_Date: Downgrade_Date
          }, splitData)
          return temp
        })

        var keysOnly = []
        for (var k = 0; k < items.length; k++) {
          keysOnly = keysOnly.concat(Object.keys(items[k]))
        }

        let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < csvKeys.length; j++) {
            if (items[i][csvKeys[j]]) {
              items[i][csvKeys[j]] = items[i][csvKeys[j]]
            } else {
              items[i][csvKeys[j]] = ''
            }
          }
        }

        // Convert to JSON and then create CSV file for download
        let cloneItems = []
        let dupItems = JSON.parse(JSON.stringify(items))
        var iIndex = 0
        for (var u = 0; u < dupItems.length; u++) {
          if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
            var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
            var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
            var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
            var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
            for (var w = 0; w < nomineeNameCount.length; w++) {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
              cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
              cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
              cloneItems[iIndex].GOM = nomineeCompanyCount[w]
              iIndex++
            }
          } else {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            iIndex++
          }
        }
        // console.log('items', items)
        // console.log(' cloneItems ', cloneItems)
        // console.log(' Object.values(cloneItems)  ', Object.values(cloneItems))
        //ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
        ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
        // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    OnTheSpotCSVCreate: function(type) {
        var self = this
        // Map fields of nominations array that will be converted to CSV
        var nominationList = []
        if (type === 'Full') {
          nominationList = self.totalNominations
        }
        if (type === 'Partial') {
          nominationList = self.nominations
        }
        const uniqueNominationList = nominationList.filter((x, index, self) => 
          index === self.findIndex((item) => item.id === x.id)
        );
        self.totalNominations = []
        nominationList = [] 
        const items = uniqueNominationList.map(function (x) {
        // const items = nominationList.map(function (x) {
        // const items = this.nominations.map(function (x) {
          console.log('exportToCSV x ', x)
          var splitData = {}
          var nomineesDetails = {}
          if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
            do {
              if (x.teamnominationworkflow[0].length === 1) {
                console.log('moved ->  ')
                x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
              }
            } while (x.teamnominationworkflow[0].length === 1)
          }
          if (x.nominationdata.length) {
            splitData = self.exportContentData(x.nominationdata)
          }
          if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
            nomineesDetails = self.exportTeamData(x.nominationteam[0])
            if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
              nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
              nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
              nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
              nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
              const result = nomineesDetails.projectSponsorApproved === 'Approve' ? 'Approved' : nomineesDetails.projectSponsorApproved === 'Reject' ? 'Rejected' : 'Pending'
              nomineesDetails.projectSponsorApproved = result
            }
          } else {
            nomineesDetails = self.getSingleNomineeInfo(x)
          }
          for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
            const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 'Pending'
            x.teamnominationworkflow[0][index].project_sponsor_status = result
          }
          let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered
          var Behavior = self.getBehavior(x)
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            GOM: nomineesDetails.gom,
            BU: nomineesDetails.businessUnit,
            Department: nomineesDetails.department,
            Country: nomineesDetails.country,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            Nominee_Status: x.nomination_approve_decline[0],
            Date_Of_Nomination: x.date.split('T')[0],
            Time_Of_Nomination: x.date.split('T')[1],
            Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
            Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
            Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
            Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Line_Manager_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
            Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
            Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
            Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
            HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
            HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
            HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            HRBP_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            Behavior: Behavior
          }, splitData)
          return temp
        })

        var keysOnly = []
        for (var k = 0; k < items.length; k++) {
          keysOnly = keysOnly.concat(Object.keys(items[k]))
        }

        let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < csvKeys.length; j++) {
            if (items[i][csvKeys[j]]) {
              items[i][csvKeys[j]] = items[i][csvKeys[j]]
            } else {
              items[i][csvKeys[j]] = ''
            }
          }
        }

        // Convert to JSON and then create CSV file for download
        let cloneItems = []
        let dupItems = JSON.parse(JSON.stringify(items))
        var iIndex = 0
        for (var u = 0; u < dupItems.length; u++) {
          if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
            var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
            var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
            var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
            var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
            for (var w = 0; w < nomineeNameCount.length; w++) {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
              cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
              cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
              cloneItems[iIndex].GOM = nomineeCompanyCount[w]
              iIndex++
            }
          } else {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            iIndex++
          }
        }
        // console.log('items', items)
        // console.log(' cloneItems ', cloneItems)
        // console.log(' Object.values(cloneItems)  ', Object.values(cloneItems))
        ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
        //ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
        // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    TeamCSVCreate: function(type) {
        var self = this
        // Map fields of nominations array that will be converted to CSV
        var nominationList = []
        if (type === 'Full') {
          nominationList = self.totalNominations
        }
        if (type === 'Partial') {
          nominationList = self.nominations
        }
        const uniqueNominationList = nominationList.filter((x, index, self) => 
          index === self.findIndex((item) => item.id === x.id)
        );
        self.totalNominations = []
        nominationList = []
        const items = uniqueNominationList.map(function (x) {
        console.log(' TeamCSVCreate called ')
        // const items = nominationList.map(function (x) {
        // const items = this.nominations.map(function (x) {
          console.log('exportToCSV x ', x)
          var splitData = {}
          var nomineesDetails = {}
          if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
            do {
              if (x.teamnominationworkflow[0].length === 1) {
                console.log('moved ->  ')
                x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
              }
            } while (x.teamnominationworkflow[0].length === 1)
          }
          if (x.nominationdata.length) {
            splitData = self.exportContentData(x.nominationdata)
          }
          if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
            nomineesDetails = self.exportTeamData(x.nominationteam[0])
            console.log(' TeamCSVCreate ', x , nomineesDetails)
            if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
              nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
              nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
              nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
              nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
              const result = nomineesDetails.projectSponsorApproved === 'Approve' ? 'Approved' : nomineesDetails.projectSponsorApproved === 'Reject' ? 'Rejected' : 'Pending'
              nomineesDetails.projectSponsorApproved = result
            }
          } else {
            nomineesDetails = self.getSingleNomineeInfo(x)
          }
          for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
            const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 'Pending'
            x.teamnominationworkflow[0][index].project_sponsor_status = result
          }
          let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered
          var Behavior = self.getBehavior(x)
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            GOM: nomineesDetails.gom,
            BU: nomineesDetails.businessUnit,
            Department: nomineesDetails.department,
            Country: nomineesDetails.country,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            Nominee_Status: x.nomination_approve_decline[0],
            Date_Of_Nomination: x.date.split('T')[0],
            Time_Of_Nomination: x.date.split('T')[1],
            Project_Sponsor: nomineesDetails.projectSponsor,
            Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
            Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
            Project_Sponsor_Date: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 0),
            Project_Sponsor_Time: self.getDateTime(nomineesDetails.projectSponsorDate, ' ', 1),
            Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
            Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
            Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
            Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Line_Manager_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
            Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
            Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
            Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
            HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
            HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
            HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            HRBP_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
            Behavior: Behavior,
          }, splitData)
          return temp
        })

        var keysOnly = []
        for (var k = 0; k < items.length; k++) {
          keysOnly = keysOnly.concat(Object.keys(items[k]))
        }

        let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < csvKeys.length; j++) {
            if (items[i][csvKeys[j]]) {
              items[i][csvKeys[j]] = items[i][csvKeys[j]]
            } else {
              items[i][csvKeys[j]] = ''
            }
          }
        }

        // Convert to JSON and then create CSV file for download
        let cloneItems = []
        let dupItems = JSON.parse(JSON.stringify(items))
        var iIndex = 0
        for (var u = 0; u < dupItems.length; u++) {
          if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
            var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
            var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
            var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
            var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
            for (var w = 0; w < nomineeNameCount.length; w++) {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
              cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
              cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
              cloneItems[iIndex].GOM = nomineeCompanyCount[w]
              iIndex++
            }
          } else {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            iIndex++
          }
        }
        // console.log('items', items)
        // console.log(' cloneItems ', cloneItems)
        // console.log(' Object.values(cloneItems)  ', Object.values(cloneItems))
        //ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
        ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
        // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    EmployeeCSVCreate: function (type,category) {
      var self = this
        var nominationList = []
        if (type === 'Full') {
          nominationList = self.totalNominations
        }
        if (type === 'Partial') {
          nominationList = self.nominations
        }
        const uniqueNominationList = nominationList.filter((x, index, self) => 
          index === self.findIndex((item) => item.id === x.id)
        );
        self.totalNominations = []
        nominationList = [] 
        const items = uniqueNominationList.map(function (x) {
        console.log(' EmployeeCSVCreate ')
        // const items = nominationList.map(function (x) {
            let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered

        //const items = this.nominations.map(function (x) {
          console.log('exportToCSV x downgrade_status', x.id, x.downgrade_status)
          var splitData = {}
          var nomineesDetails = {}
          if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
            do {
              if (x.teamnominationworkflow[0].length === 1) {
                console.log('moved ->  ')
                x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
              }
            } while (x.teamnominationworkflow[0].length === 1)
          }
          if (x.nominationdata.length) {
            splitData = self.exportContentData(x.nominationdata)
          }
          if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
            nomineesDetails = self.exportTeamData(x.nominationteam[0])
          } else {
            nomineesDetails = self.getSingleNomineeInfo(x)
          }
          console.log('team length ', x.teamnominationworkflow[0].length, x.teamnominationworkflow[0])
          for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
              console.log(' x489 ', x.teamnominationworkflow[0][index].project_sponsor_status, x.teamnominationworkflow[0][index].project_sponsor_name)
              const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
            x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 
            'Pending'
              x.teamnominationworkflow[0][index].project_sponsor_status = result
            console.log(' x489 577 ', result, x.teamnominationworkflow[0][index].project_sponsor_status)
          }
          const temp = Object.assign({}, {
            Post_ID: x.id.toString(),
            Nominator_Name: x._embedded.author[0].name,
            Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
            Nominee_Name: nomineesDetails.nomineeName,
            Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
            Nominee_Email: nomineesDetails.nomineeEmail,
            GOM: nomineesDetails.gom,
            BU: nomineesDetails.businessUnit,
            Department: nomineesDetails.department,
            Country: nomineesDetails.country,
            Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
            Nominee_Status: x.nomination_approve_decline[0],
            Date_Of_Nomination: x.date.split('T')[0],
            Time_Of_Nomination: x.date.split('T')[1],
            selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
            Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
            Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
            Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
            Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
            Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
          }, splitData)
          return temp
        })

        var keysOnly = []
        for (var k = 0; k < items.length; k++) {
          //console.log(' k ', k, items[k])
          keysOnly = keysOnly.concat(Object.keys(items[k]))
        }
        console.log(' keysOnly ', keysOnly)
        let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
        console.log(' csvKeys ', csvKeys)
        for(var i = 0; i < csvKeys.length; i++) {
          if (csvKeys[i] === 'Why are you nominating this person?' || csvKeys[i] === 'Why are you nominating this team?') {
            //csvKeys[i] = 'Nominator Motivation Reason'
          }
        }
        for (var i = 0; i < items.length; i++) {
          for (var j = 0; j < csvKeys.length; j++) {
            if (items[i][csvKeys[j]]) {
              items[i][csvKeys[j]] = items[i][csvKeys[j]]
            } else {
              items[i][csvKeys[j]] = ''
            }
          }
        }
        for(var i = 0; i < csvKeys.length; i++) {
          if (csvKeys[i] === 'Why are you nominating this person?' || csvKeys[i] === 'Why are you nominating this team?') {
            console.log(' csvKeys[i] ', i, csvKeys[i])
            csvKeys[i] = 'Nominator Motivation Reason'
          }
        }
        // Convert to JSON and then create CSV file for download
        let cloneItems = []
        let dupItems = JSON.parse(JSON.stringify(items))
        var iIndex = 0
        for (var u = 0; u < dupItems.length; u++) {
          if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
            var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
            var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
            var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
            var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
            for (var w = 0; w < nomineeNameCount.length; w++) {
              cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
              cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
              cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
              cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
              cloneItems[iIndex].GOM = nomineeCompanyCount[w]
              iIndex++
            }
          } else {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            iIndex++
          }
        }
        console.log('items', items)
        ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
        
        //ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    BUEOYCSVCreate: function(type) {
      var self = this
      // Map fields of nominations array that will be converted to CSV
      var nominationList = []
      if (type === 'Full') {
        nominationList = self.totalNominations
      }
      if (type === 'Partial') {
        nominationList = self.nominations
      }
      const items = nominationList.map(function (x) {
        console.log('exportToCSV x ', x)
        var splitData = {}
        var nomineesDetails = {}
        if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
          do {
            if (x.teamnominationworkflow[0].length === 1) {
              console.log('moved ->  ')
              x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
            }
          } while (x.teamnominationworkflow[0].length === 1)
        }
        if (x.nominationdata.length) {
          splitData = self.exportContentData(x.nominationdata)
        }
        nomineesDetails = self.getSingleNomineeInfo(x)
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          Country: nomineesDetails.country,
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          AwardType: (x.winnerRunnerStatus && x.winnerRunnerStatus[0] !== null) ? x.winnerRunnerStatus[0] : '',
          GOM: nomineesDetails.gom,
          BU: nomineesDetails.businessUnit,
          Department: nomineesDetails.department
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }

      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)

      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }

      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      console.log('items', items)
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
    },
    MCGEOYCSVCreate: function (type) {
      var self = this
      var self = this
      var nominationList = []
      if (type === 'Full') {
        nominationList = self.totalNominations
      }
      if (type === 'Partial') {
        nominationList = self.nominations
      }
      const items = nominationList.map(function (x) {
        console.log('exportToCSV x ', x)
        var splitData = {}
        var nomineesDetails = {}
        if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
          do {
            if (x.teamnominationworkflow[0].length === 1) {
              console.log('moved ->  ')
              x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
            }
          } while (x.teamnominationworkflow[0].length === 1)
        }
        if (x.nominationdata) {
          splitData = self.exportContentData(x.nominationdata)
        }
        if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
          nomineesDetails = self.exportTeamData(x.nominationteam[0])
          console.log('404 ', nomineesDetails)
        } else {
          nomineesDetails = self.getSingleNomineeInfo(x)
          console.log('474 ', nomineesDetails)
        }

        if (nomineesDetails && typeof nomineesDetails.nomineeName === 'string') {
          var nomineeNameRaw = nomineesDetails.nomineeName
        } else {
          var nomineeNameRaw = ''
        }

        var nomineeNameCount = nomineeNameRaw.split(' $&$ ')

        // Ensure it always has at least 3 entries
        while (nomineeNameCount.length < 3) {
          nomineeNameCount.push('')
        }
        var GOMList =  (x.MCGEOYOption1 && x.MCGEOYOption1[0] && x.MCGEOYOption1[0].GOM || '') + ' $&$ ' +  
        (x.MCGEOYOption2 && x.MCGEOYOption2[0] && x.MCGEOYOption2[0].GOM || '') + ' $&$ ' +  
        (x.MCGEOYOption3 && x.MCGEOYOption3[0] && x.MCGEOYOption3[0].GOM || '')
        console.log(' GOMList ', GOMList)
        const temp = Object.assign({}, {
          Nominator_Name: x._embedded.author[0].name,
          Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
          Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
          Nominee_Name: nomineesDetails.nomineeName,
          Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
          Nominee_Email: nomineesDetails.nomineeEmail,
          GOM: GOMList,
          BU: nomineesDetails.businessUnit,
          Country: nomineesDetails.country,
          option1: nomineeNameCount[0],
          option2: nomineeNameCount[1],
          option3: nomineeNameCount[2]
        }, splitData)
        return temp
      })

      var keysOnly = []
      for (var k = 0; k < items.length; k++) {
        //console.log(' k ', k, items[k])
        keysOnly = keysOnly.concat(Object.keys(items[k]))
      }
      console.log(' keysOnly ', keysOnly)
      let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
      console.log(' csvKeys ', csvKeys)
      for (var i = 0; i < items.length; i++) {
        for (var j = 0; j < csvKeys.length; j++) {
          if (items[i][csvKeys[j]]) {
            items[i][csvKeys[j]] = items[i][csvKeys[j]]
          } else {
            items[i][csvKeys[j]] = ''
          }
        }
      }
      // Convert to JSON and then create CSV file for download
      let cloneItems = []
      let dupItems = JSON.parse(JSON.stringify(items))
      console.log(' dupItems ', dupItems)
      var iIndex = 0
      for (var u = 0; u < dupItems.length; u++) {
        if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
          var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
          var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
          var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
          //var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
          for (var w = 0; w < nomineeNameCount.length; w++) {
            cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
            cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
            cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
            cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
            //cloneItems[iIndex].GOM = nomineeCompanyCount[w]
            iIndex++
          }
        } else {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          iIndex++
        }
      }
      console.log('items', items)
      ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination'])
    },    
    fullExportGenerateSearchQuery: function () {
      
      let string = '?nomination_categories=102,103,104,100,138'
      return string
    },
    exportFullReportToCSV: function () {
      if (this.fromDate && this.toDate) {
      this.buttonExportFullReportDisabled = true
      this.isPopupVisible = true      
      this.totalLoadNominations('export',false)
      .then(() => {
	    if (this.totalNominations.length > 0) {
			if (this.nominationCategorySelect === 102) {
			  this.high5CSVCreate('Full')
			}
			else if (this.nominationCategorySelect === 103) {
			  this.OnTheSpotCSVCreate('Full')
			}
			else if (this.nominationCategorySelect === 104) {
			  this.TeamCSVCreate('Full')
			}
			else if (this.nominationCategorySelect === 139) {
              this.BUEOYCSVCreate('Full')
            }
            else if (this.nominationCategorySelect === 140) {
              this.MCGEOYCSVCreate('Full')
            }
			else if (this.nominationCategorySelect === 141) {
              this.RegionaLEOMCSVCreate('Full')
            }
			else if (this.nominationCategorySelect === 100 || this.nominationCategorySelect === 138) {
			  this.EmployeeCSVCreate('Full', this.nominationCategorySelect)
			} else {
			  const uniqueNominationList = this.totalNominations.filter((x, index, self) => 
                index === self.findIndex((item) => item.id === x.id)
              )  
			  var self = this
			  // Map fields of totalNominations array that will be converted to CSV
			  const items = uniqueNominationList.map(function (x) {
				var splitData = {}
				var nomineesDetails = {}
				do {
				  if (x.teamnominationworkflow[0].length === 1) {
					console.log('moved ->  ')
					x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
				  }
				} while (x.teamnominationworkflow[0].length === 1)
		
				if (x.nominationdata.length) {
				  splitData = self.exportContentData(x.nominationdata)
				}
				if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
				  nomineesDetails = self.exportTeamData(x.nominationteam[0])
                  console.log(' TeamCSVCreate ', x , nomineesDetails)
				  if (x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor')).length > 0) {
					nomineesDetails.projectSponsor = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_email'] : ''
					nomineesDetails.projectSponsorApproved = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_status'] : ''
					nomineesDetails.projectSponsorDeclinedReason = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_comment'] : ''
					nomineesDetails.projectSponsorDate = (x.teamnominationworkflow.length) ? x.teamnominationworkflow[0].filter(m => (m.project_sponsor_name === 'Sponsor'))[0]['project_sponsor_datetime'] : ''
					const result = nomineesDetails.projectSponsorApproved === 'Approve' ? 'Approved' : nomineesDetails.projectSponsorApproved === 'Reject' ? 'Rejected' : 'Pending'
					nomineesDetails.projectSponsorApproved = result
				  }
				} else {
				  nomineesDetails = self.getSingleNomineeInfo(x)  
				  //nomineesDetails = {nomineeName: x.nominee_name[0], nomineeEmployeNumber: x.nominee_employeeNumber[0], nomineeEmail: x.nominee_slug[0].replace(/multichoice/g, '@multichoice').replace(/-/g, '.'), nomineeCompany: (x.nominee_company.length) ? x.nominee_company[0].replace(/,/g, ' ') : '', projectSponsor: '', projectSponsorApproved: '', projectSponsorDeclinedReason: '', projectSponsorDate: ''}
				}
				console.log('team length ',x,  x.teamnominationworkflow[0].length, x.teamnominationworkflow[0])
				if (x.teamnominationworkflow && x.teamnominationworkflow[0] && x.teamnominationworkflow[0].length) {
				    console.log(' 1159 ', x)
				}
				for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
				  console.log(' x489 ', x.teamnominationworkflow[0][index].project_sponsor_status, x.teamnominationworkflow[0][index].project_sponsor_name)
				  const result = x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' ? 'Approved' : x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' ? 'Rejected' : 'Pending'
				  console.log(result);
				  x.teamnominationworkflow[0][index].project_sponsor_status = result
				}

				let Downgrade_Status = ''
				let Downgrade_Date = ''
				let Downgrade_User = ''
				let Award_Category = (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered
				console.log(' exportMasterCSV self.nominationCategorySelect === 102 ', self.nominationCategorySelect, x.downgrade_status, Award_Category)
				if (Award_Category === 'High5') {
					Downgrade_Status = (x.downgrade_status && x.downgrade_status !== null) ? 'Downgraded to High5' :  'Normal High5'
					if (Downgrade_Status === 'Downgraded to High5') {
						Downgrade_Date = x.teamnominationworkflow[0][0].project_sponsor_datetime
						Downgrade_User = (x.downgrade_user && x.downgrade_user !== null) ? (x.downgrade_user) : ''
					}
				}

				let Behavior = self.getBehavior(x)
				console.log(' Behavior ', Behavior)
				if (self.nominationCategorySelect === 100 || self.nominationCategorySelect === 138) {
				const temp = Object.assign({}, {
                    Post_ID: x.id.toString(),
					Nominator_Name: x._embedded.author[0].name,
					Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
					Nominee_Name: nomineesDetails.nomineeName,
					Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
					Nominee_Email: nomineesDetails.nomineeEmail,
					GOM: nomineesDetails.gom,
					BU: nomineesDetails.businessUnit,
					Department: nomineesDetails.department,
					Country: nomineesDetails.country,
					Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
					Nominee_Status: x.nomination_approve_decline[0],
					Date_Of_Nomination: x.date.split('T')[0],
					Time_Of_Nomination: x.date.split('T')[1],
					selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
					 Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
                    Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
                    Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
                    Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
                    Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
                    Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
                    Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
                    Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || '') : '',
                    HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
                    HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
                    HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
                    HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || '') : '',

					Behavior: Behavior
				  }, splitData)
				  return temp
				}
				else {
					const temp = Object.assign({}, {
                      Post_ID: x.id.toString(),
					  Nominator_Name: x._embedded.author[0].name,
					  Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
					  Nominee_Name: nomineesDetails.nomineeName,
					  Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
					  Nominee_Email: nomineesDetails.nomineeEmail,
					  GOM: nomineesDetails.nomineeCompany,
					  Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
					  Nominee_Status: x.nomination_approve_decline[0],
					  Date_Of_Nomination: x.date.split('T')[0],
					  Time_Of_Nomination: x.date.split('T')[1],
					  selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
					  Project_Sponsor: nomineesDetails.projectSponsor,
					  Project_Sponsor_Approved: nomineesDetails.projectSponsorApproved,
					  Project_Sponsor_Reason: nomineesDetails.projectSponsorDeclinedReason,
					  Project_Sponsor_Date: nomineesDetails.projectSponsorDate,
					  Line_Manager: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_email || '') : '',
                      Line_Manager_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_status || '') : '',
                      Line_Manager_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_comment || '') : '',
                      Line_Manager_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Manager')[0] || {}).project_sponsor_datetime || '') : '',
                      Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
                      Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
                      Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
                      Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || '') : '',
                      HRBP: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_email || '') : '',
                      HRBP_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_status || '') : '',
                      HRBP_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_comment || '') : '',
                      HRBP_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'HRBP')[0] || {}).project_sponsor_datetime || '') : '',
					  Downgrade_Status: Downgrade_Status,
					  Downgrade_Date: Downgrade_Date,
					  Downgrade_User: Downgrade_User,
					  Behavior: Behavior
					}, splitData)
					return temp
				}
			  })
		
			  var keysOnly = []
			  for (var k = 0; k < items.length; k++) {
				keysOnly = keysOnly.concat(Object.keys(items[k]))
			  }
		
			  let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
		
			  for (var i = 0; i < items.length; i++) {
				for (var j = 0; j < csvKeys.length; j++) {
				  if (items[i][csvKeys[j]]) {
					items[i][csvKeys[j]] = items[i][csvKeys[j]]
				  } else {
					items[i][csvKeys[j]] = ''
				  }
				}
			  }
		
			  // Convert to JSON and then create CSV file for download
			  let cloneItems = []
			  let dupItems = JSON.parse(JSON.stringify(items))
			  console.log('dupItems ', dupItems)
			  var iIndex = 0
			  for (var u = 0; u < dupItems.length; u++) {
				console.log('u ' + u, dupItems[u])
				if (dupItems[u].Nominee_Name.includes(' & ')) {
				  var nomineeNameCount = dupItems[u].Nominee_Name.split(' & ')
				  var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' & ')
				  var nomineeEmailCount = dupItems[u].Nominee_Email.split(' & ')
				  var nomineeCompanyCount = dupItems[u].GOM.split(' & ')
				  for (var w = 0; w < nomineeNameCount.length; w++) {
					console.log(w, nomineeNameCount[w])
					cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
					cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
					cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
					cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
					cloneItems[iIndex].GOM = nomineeCompanyCount[w]
					iIndex++
				  }
				  console.log(u, cloneItems)
				} else {
				  cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
				  iIndex++
				}
			  }
		
			  ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name')
			  // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations', 'dateOfNomination')
			}
		} else {
			alert("No record to download report in given date range.")
		}
		this.isPopupVisible = false
        this.buttonExportFullReportDisabled = false
      })
      .catch(error => {
        console.error('Error:', error);
        // Handle the error if needed
        this.isPopupVisible = false
        this.buttonExportFullReportDisabled = false
      });
      } else {
        if (!this.fromDate || !this.toDate) {
            alert('Please select date range')
        }
      }
    },
    RegionaLEOMCSVCreate: function (type) {
      var self = this
      var nominationList = []
      if (type === 'Full') {
        nominationList = self.totalNominations
      }
      if (type === 'Partial') {
        nominationList = self.nominations
      }
      // Map fields of nominations array that will be converted to CSV
      const items = nominationList.map(function (x) {
      console.log('exportToCSV x downgrade_status', x.id, x.downgrade_status)
      var splitData = {}
      var nomineesDetails = {}
      if (x.nomination_event_category[0] !== 19 && x.nomination_event_category[0] !== 18 && x.nomination_event_category[0] !== 17) {
        do {
          if (x.teamnominationworkflow[0].length === 1) {
            console.log('moved ->  ')
            x.teamnominationworkflow[0] = x.teamnominationworkflow[0][0]
          }
        } while (x.teamnominationworkflow[0].length === 1)
      }
      if (x.nominationdata.length) {
        splitData = self.exportContentData(x.nominationdata)
      }
      if (x.isteamaward[0] === 'true' || x.nominationteam[0]) {
        nomineesDetails = self.exportTeamData(x.nominationteam[0])
      } else {
        nomineesDetails = self.getSingleNomineeInfo(x)
      }
      console.log('team length ', x.teamnominationworkflow[0].length, x.teamnominationworkflow[0])
      for (let index = 0; index < x.teamnominationworkflow[0].length; index++) {
          console.log(' x489 ', x.teamnominationworkflow[0][index].project_sponsor_status, x.teamnominationworkflow[0][index].project_sponsor_name)
          const result =   x.teamnominationworkflow[0][index].project_sponsor_status === 'Approve' || 
        x.teamnominationworkflow[0][index].project_sponsor_status === 'Approved' ? 'Approved' :
        x.teamnominationworkflow[0][index].project_sponsor_status === 'Reject' || 
        x.teamnominationworkflow[0][index].project_sponsor_status === 'Rejected' ? 'Rejected' : 
        'Pending'
          x.teamnominationworkflow[0][index].project_sponsor_status = result
        console.log(' x489 577 ', result, x.teamnominationworkflow[0][index].project_sponsor_status)
      }
      const temp = Object.assign({}, {
        Nominator_Name: x._embedded.author[0].name,
        Nominator_Employee_Number: x.nominator_details[0][0]['employee-number'],
        Nominee_Name: nomineesDetails.nomineeName,
        Nominee_Employee_Number: nomineesDetails.nomineeEmployeNumber,
        Nominee_Email: nomineesDetails.nomineeEmail,
        GOM: nomineesDetails.gom,
        BU: nomineesDetails.businessUnit,
        Department: nomineesDetails.department,            
        Country: nomineesDetails.country,
        Award_Category: (x._embedded['wp:term'][1].length) ? x._embedded['wp:term'][1][0].name : x.title.rendered,
        Nominee_Status: x.nomination_approve_decline[0],
        Date_Of_Nomination: x.date.split('T')[0],
        Time_Of_Nomination: x.date.split('T')[1],
        selection_period: (x.selectionperiod && x.selectionperiod.length && x.selectionperiod[0] !== null && x.selectionperiod[0] !== undefined) ? (x.selectionperiod[0]) : '',
        Exco2: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_email || '') : '',
        Exco2_Approved: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_status || '') : '',
        Exco2_Reason: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? ((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_comment || '') : '',
        Exco2_Date: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 0) : '',
        Exco2_Time: (x.teamnominationworkflow && x.teamnominationworkflow[0] !== null) ? self.getDateTime(((x.teamnominationworkflow[0].filter(m => m.project_sponsor_name === 'Exco2')[0] || {}).project_sponsor_datetime || ''), ' ', 1) : '',
        EmployeeAwardCountry: x.EmployeeAwardCountry[0],
        EmployeeAwardRegion: x.EmployeeAwardRegion[0],
      }, splitData)
      return temp
    })

    var keysOnly = []
    for (var k = 0; k < items.length; k++) {
      //console.log(' k ', k, items[k])
      keysOnly = keysOnly.concat(Object.keys(items[k]))
    }

    let csvKeys = keysOnly.filter((v, i) => keysOnly.indexOf(v) === i)
    console.log(' csvKeys ', csvKeys)
    for(var i = 0; i < csvKeys.length; i++) {
      if (csvKeys[i] === 'Why are you nominating this person?' || csvKeys[i] === 'Why are you nominating this team?') {
        console.log(' csvKeys[i] ', i, csvKeys[i])
        //csvKeys[i] = 'Nominator Motivation Reason'
      }
    }
    for (var i = 0; i < items.length; i++) {
      for (var j = 0; j < csvKeys.length; j++) {
        if (items[i][csvKeys[j]]) {
          items[i][csvKeys[j]] = items[i][csvKeys[j]]
        } else {
          items[i][csvKeys[j]] = ''
        }
      }
    }

    // Convert to JSON and then create CSV file for download
    let cloneItems = []
    let dupItems = JSON.parse(JSON.stringify(items))
    var iIndex = 0
    for (var u = 0; u < dupItems.length; u++) {
      if (dupItems[u].Nominee_Name.includes(' $&$ ')) {
        var nomineeNameCount = dupItems[u].Nominee_Name.split(' $&$ ')
        var nomineeEmployeNumberCount = dupItems[u].Nominee_Employee_Number.split(' $&$ ')
        var nomineeEmailCount = dupItems[u].Nominee_Email.split(' $&$ ')
        var nomineeCompanyCount = dupItems[u].GOM.split(' $&$ ')
        for (var w = 0; w < nomineeNameCount.length; w++) {
          cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
          cloneItems[iIndex].Nominee_Name = nomineeNameCount[w]
          cloneItems[iIndex].Nominee_Employee_Number = nomineeEmployeNumberCount[w]
          cloneItems[iIndex].Nominee_Email = nomineeEmailCount[w]
          cloneItems[iIndex].GOM = nomineeCompanyCount[w]
          iIndex++
        }
      } else {
        cloneItems[iIndex] = JSON.parse(JSON.stringify(dupItems[u]))
        iIndex++
      }
    }
    console.log('items', items)
    ExportToCSV.createCSV(items, 'Recognition', 'Nominee_Name', ['Date_Of_Nomination', 'Project_Sponsor', 'Project_Sponsor_Approved', 'Project_Sponsor_Reason', 'Project_Sponsor_Date', 'Project_Sponsor_Time', 'Line_Manager', 'Line_Manager_Approved', 'Line_Manager_Reason', 'Line_Manager_Date', 'Line_Manager_Time', 'Exco2', 'Exco2_Approved', 'Exco2_Reason', 'Exco2_Date', 'Exco2_Time', 'HRBP', 'HRBP_Approved', 'HRBP_Reason', 'HRBP_Date', 'HRBP_Time'])
    // ExportToCSV.createCSV(Object.values(cloneItems), 'VE_Awards_Nominations')
    },
    getBehavior: function (x) {
      if (x._embedded && x._embedded["wp:term"]) {
          const terms = x._embedded["wp:term"];
          if (terms.length > 0) {
              const lastTermsGroup = terms[terms.length - 1]
              let i = 0
              for (i = 0; i < lastTermsGroup.length; i++) {
                if (lastTermsGroup[i].id > 106 && lastTermsGroup[i].id < 115) {
                    return lastTermsGroup[i].name
                }
              }
          }
      }
      return ''
    },
    showHideFilters: function () {
      if (this.showHideFilterText === '<i class="fas fa-angle-up"></i>') {
        this.showHideFilterText = '<i class="fas fa-angle-down"></i>'
      } else {
        this.showHideFilterText = '<i class="fas fa-angle-up"></i>'
      }
    },
    filterByGraduatedNominations: function () {
      if (this.graduatedNominationsCheck) {
        this.nominationCategorySelect = 45
      } else {
        this.nominationCategorySelect = '-- All --'
      }
      this.loadNominations()
    },
    dateFilters: function () {
      this.validateDates()
      console.log('date filter called', this.fromDate , this.toDate)
      if (this.fromDate && this.toDate) {
        console.log('load nomination called')
          this.loadNominations()
      }
    },
    getDateTime: function (val, needle, index) {
      if(val !== undefined && val !== null && val !== "" && val !== "NA") {
        return val.split(needle)[index]
      } else {
        return ''
      }
    },
    changeItemPerPage: function () {
      this.currentPage = 1
      //this.loadNominations()
      //this.currentPage = 0
      let index = 0
      console.log(' changeItemPerPage this.itemsPerPage ', this.itemsPerPage)
      if (this.itemsPerPage > 1000) {
        console.log('changeItemPerPage before calling totalLoadNominations')
        this.totalLoadNominations('load',true)
        .then(() => {
          this.nominations = []
          console.log('changeItemPerPage Nominations fetching complete this.totalNominations.length ', this.totalNominations.length)
          this.nominations = this.totalNominations.slice(0, this.itemsPerPage)
          console.log('changeItemPerPage  after totalLoadNominations called', this.nominations)
          this.totalNominations = []
          // Continue with further processing once all records are fetched
        })
        .catch(error => {
          console.error('Error:', error);
          // Handle the error if needed
        })
      } else {
         this.loadNominations()
      }
    },
    generateSearchQuery: function () {
        let offset = Math.max(this.currentPage - 1, 0) * this.itemsPerPage
        console.log(' offset ', offset, this.currentPage, Math.max(this.currentPage - 1,0))
        let string = '?perPage='+this.itemsPerPage+'&offset='+offset
        if (this.nominationCategorySelect === '-- All --'){
          string = string+'&nomination_categories=102,103,104,100,138'
        } else {
          string = string+'&nomination_categories=' + this.nominationCategorySelect
        }
        console.log('generateSearchQuery this.fromDate ', this.fromDate, ' this.toDate ', this.toDate)
        if (this.fromDate && this.toDate) {
          console.log(' string  '+string)
          string = string+'&from='+this.fromDate+'&to='+this.toDate
        }
        console.log('string ', string)
        return string
      },
    totalLoadNominations: async function (type,date_filter) {
      let currentPage = 0
      const perPageVal = 'perPage=250'
      let offset = 0
      this.totalNominations = []
      while (true) {
        try {
          console.log('totalLoadNominations this.nominationCategorySelect ', this.nominationCategorySelect)
          let query = 'getNomination/v1/getusernominationForFullReport?nomination_categories=' + this.nominationCategorySelect + '&offset=' + offset + '&' + perPageVal
          if (date_filter) {
              query = 'getNomination/v1/getusernominationForFullReport?nomination_categories=' + this.nominationCategorySelect + '&offset=' + offset + '&' + perPageVal + '&from=' + this.fromDate +'&to=' + this.toDate
          }
          console.log(' query ', query)
          const response = await WordpressRestAPI.getCustomViewContent(query)

          if (response.data != false) {
              this.totalNominations.push(...response.data.data);
          } else {
              console.log('before break')
              break;
          }
          console.log('Total Nominations:', this.totalNominations.length, response.data.data.length)
          console.log(' offset ', offset, ' perPageVal ', perPageVal)
          if (type === 'export') {
            if (response.data.data.length < 250 || response.data === false ) {
                break;
            }
          }
          if (type === 'load') {
              if (response.data.length < 250 || this.totalNominations.length >= this.itemsPerPage ) {
                console.log('totalLoadNominations inside break')
                console.log('totalLoadNominations  response.data.length ', response.data.length, ' this.totalNominations ', this.totalNominations)
                break;
              }
          }
          currentPage++;
          offset = currentPage * 250
        } catch (e) {
          this.contentLoadError = 'Oops! We had a problem loading nominations. Please try again later.';
          console.error(e);
          break; // Exit the loop on error
        }
      }
    },
    generateSearchQuery_new: function () {
      let userEmails = [this.userDetails.email.toLowerCase(), this.userDetails.username.toLowerCase()]
      let offset = Math.max(this.currentPage - 1, 0) * this.itemsPerPage
      console.log(' offset ', offset, this.currentPage, Math.max(this.currentPage - 1,0))
      let string = '?email=' + userEmails+'&type='+this.userType+'&perPage='+this.itemsPerPage+'&offset='+offset
      if (this.nominationCategorySelect === '-- All --'){
        string = string+'&nomination_categories=102,103,104,100,138'
      } else {
        string = string+'&nomination_categories=' + this.nominationCategorySelect
      }
      if (this.fromDate && this.toDate) {
        console.log(' string  '+string)
        string = string+'&from='+this.fromDate+'&to='+this.toDate
      }
      console.log('string ', string)
      return string
    },
    loadNominations: function () {
      this.contentReady = false
      console.log('before calling userEmails')
      WordpressRestAPI.getCustomViewContent('getNomination/v1/getusernominationForFullReport'+this.generateSearchQuery())
      .then(response => {
        console.log('review list-> ', response.data)
        if (response.data !== false) {
          console.log(' response.data ', response.data)
          this.nominations = response.data['data']
          //this.totalPageNominations = response.data['data']
          this.totalPosts = response.data['total_post']
          console.log(' this.totalPosts ', this.totalPosts, parseInt(response.headers['x-wp-total']))  
          this.getNominationCounts()
        } else {
          this.nominations= []
          this.totalPosts = 0
          this.totalRecords = 0
          this.approved = 0
          this.rejected = 0
          this.pending = 0
        }
        this.contentReady = true
      })
      .catch(e => {
        this.contentReady = true
        this.childContentLoadError = 'Oops! We had a problem with loading your nominations. Please try again later.'
        console.error(e)
      })
    },
    filterByNominee: function () {
      this.nominations = this.unfilteredNominations
      var self = this
      if (this.nomineeFilter !== '' && this.nomineeFilterButton === '+') {
        this.nominations = this.nominations.filter(x => x.nominee_name[0].toLowerCase().indexOf(self.nomineeFilter.toLowerCase()) > -1)
      }
      if (this.nomineeFilterButton === '+') {
        this.nomineeFilterButton = 'x'
      } else {
        this.nomineeFilterButton = '+'
        this.nomineeFilter = ''
      }
    },
    filterByNominator: function () {
      this.nominations = this.unfilteredNominations
      if (this.nominatorFilter !== '' && this.nominatorFilterButton === '+') {
        this.nominations = this.nominations.filter(x => x._embedded.author[0].name.toLowerCase().indexOf(this.nominatorFilter.toLowerCase()) > -1)
      }
      if (this.nominatorFilterButton === '+') {
        this.nominatorFilterButton = 'x'
      } else {
        this.nominatorFilterButton = '+'
        this.nominatorFilter = ''
      }
    },
    filterByStatus: function (status) {
      this.nominations = this.unfilteredNominations
      if (status !== 'All') {
        this.nominations = this.nominations.filter(x => x.nomination_approve_decline[0] === status)
      }
    },
    hidePopup() {
      this.isPopupVisible = false;
    },
  },
  watch: {
    'currentPage' (newDetails, oldDetails) {
      this.loadNominations()
    }
  }
}
</script>

<style lang="less">
  .showHideBtn {
    padding: 4px 8px;
  }
  .popup {
    position: fixed;
    top: 25%;
    left: 50%;
    height:110px;
    width:600px;
    transform: translate(-50%, -50%);
    background-color: white;
    padding: 20px;
    border: 1px solid #ccc;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    z-index:1001
  }
  .close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 18px;
    cursor: pointer;
    height: 28px;
    width: 25px;
    border: 1px solid rgb(0, 0, 0);
  }
</style>


// WEBPACK FOOTER //
// src/components/routes/VEAwardForAllGroups.vue